import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../authentication/auth.service';
import { map } from 'rxjs';

export const LoginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const isLoggedIn = authService.isLoggedInObs();
  return isLoggedIn.pipe(
    map(loggedIn=>{
      return loggedIn ? router.createUrlTree(['/home']) : true; 
    }))
}
